// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 3.5H13M3 8H7M3 12.5H13',
  'M11.5 5.75V10.25M9.25 8H13.75',
];
